inicio.component('inicio.inicioComponent', {
    templateUrl: 'inicio/inicio.html',
    controller: 'inicio.inicioController',
    controllerAs: '$ctrl'
});

inicio.controller('inicio.inicioController', ['$rootScope', '$scope', 'coreLanguage', '$state', 'coreFb', '$filter', function($rootScope, $scope, $text, $state, $fb, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.areaMembros = {};
    $ctrl.acessoExtraModal=false;

    const _getAreaMembros=(idArea)=>{

        $fb.db.get(`cad_areaMembros/${idArea}`).then(doc=>{
            $ctrl.areaMembros = doc;
            $state.params.showGlobalLoading = false;

        }).catch(e=>{
            console.log(e);
        });
    };

    const _getHasAcessoExtra=()=>{
       
        $fb.functions.invoke('fatura_hasAcessoExtra').then((res)=>{
            $ctrl.acessoExtra = res;
        });
    };

    const _getUserName=(idUsuario)=>{
        $fb.db.get(`cad_usuarios/${idUsuario}`).then(doc=>{
            $ctrl.userName=doc.data.nome.split(' ')[0];
        }).catch(e=>{});
    };

    const _setMotivacao=async()=>{
        let filePath = './inicio/motiva.json';

        let motivacaoDia = localStorage.getItem("motivacao");
        
        let hoje = new Date();
        let dateStr = $filter('date')(hoje, 'yyyyMMdd');

        try {
            const resposta = await fetch(filePath);
            
            if (!resposta.ok) {
                throw new Error(`Erro ao carregar frases.`);
            }
            
            const objeto = await resposta.json();

            if(motivacaoDia){
                let dados = motivacaoDia.split('-');
                if(dados[0] === dateStr){
                    let idx = parseInt(dados[1]);
                    $ctrl.motivacao = objeto[idx];

                    return;
                }
            };

            let idx = Math.floor(Math.random() * (objeto.length + 1));
            $ctrl.motivacao = objeto[idx];

            localStorage.setItem("motivacao", `${dateStr}-${idx}`);
            
        } catch (erro) {
            console.error("Erro na leitura:", erro);
        };

    };

    $ctrl.setAcessoExtraModal=(value)=>{
        $ctrl.acessoExtraModal = value;
    };

    $ctrl.enviarAcessoExtra=(email)=>{
        $ctrl.invalidEmail = false;
        $ctrl.loading = true;

        if(!email || !email.length){
            $ctrl.invalidEmail = true;
            $ctrl.loading = false;
            return;
        }

        $fb.functions.invoke('fatura_sendAcesso', {email: email}).then(()=>{
            $state.reload();
        });

    };

    $ctrl.goLink=(link)=>{
        if(!link){
            return;
        }

        window.open(link, '_blank');

    };

    $ctrl.$onInit = () => {
        let idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;
        
        _getHasAcessoExtra();
        
        _getAreaMembros(idAreaMembros);

        $scope.isDesktop = $rootScope.isDesktop;

        _getUserName($fb.auth.getIdToken().claims.idUsuario);

        _setMotivacao();
    };
    
}]);